/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  var elem = document.querySelector('.multi_icon_text_wrp');
  var flkty = new Flickity( elem, {
    cellAlign: 'left',
    adaptiveHeight: true,
    prevNextButtons: false,
    wrapAround: true,
    responsive: [
    {
      breakpoint: 749,
      settings: {
        adaptiveHeight: true,
      }
    }
  ]
  });
  
  var elem = document.querySelector('.multi-video-block .video-container');
  var flkty = new Flickity( elem, {
    cellAlign: 'left',
    adaptiveHeight: false,
    prevNextButtons: false,
    wrapAround: true
  });
  var progressBar = document.querySelector('.multi-video-block .progress-bar')

flkty.on( 'scroll', function( progress ) {
  progress = Math.max( 0, Math.min( 1, progress ) );
  progressBar.style.width = progress * 100 + '%';
}); 
  
  var elem = document.querySelector('.customer_review .customer_card_slider');
  var flkty = new Flickity( elem, {
    cellAlign: 'left',
    adaptiveHeight: false,
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: true
  });

  
  var elem = document.querySelector('.instagram_section_wrp');
  var flkty = new Flickity( elem, {
    cellAlign: 'left',
    wrapAround: true,
    prevNextButtons: true,
    pageDots: false
  });
  
})();

$(document).ready(function(){
  $(function () {
    	$('.popup-modal').magnificPopup({
    		type: 'inline',
    		preloader: false,
    		focus: '#username',
    		modal: true
    	});
    	$(document).on('click', '.popup-modal-dismiss', function (e) {
    		e.preventDefault();
    		$.magnificPopup.close();
    	});
  });
});


// Select all carousel items
var buttons = document.querySelectorAll("div.video-container .carousel__item");

// Add click event to each carousel item
buttons.forEach(function (button) {
  button.addEventListener("click", function () {
    // Pause all videos and remove "active" class from all items
    buttons.forEach(function (otherButton) {
      var otherVideo = otherButton.querySelector("video");
      if (otherVideo) {
        otherVideo.pause();
        otherVideo.setAttribute("status", "paused");
      }
      otherButton.classList.remove("active");
    });

    // Add "active" class to the clicked item
    button.classList.add("active");

    // Play the video inside the clicked item
    var video = button.querySelector("video");
    if (video) {
      video.setAttribute("status", "play");
      video.play();
    }
  });
});


window.addEventListener('scroll', function() {
        const myElement = document.getElementById('sticky-bottom-cart');
        if (window.scrollY > 500) {
            myElement.classList.add('sticky-visible');
        } else {
            myElement.classList.remove('sticky-visible');
        }
    });


if (window.innerWidth < 750) {
  var elem = document.querySelector('.step-lists.carousel');
  var flkty = new Flickity( elem, {
    cellAlign: 'left',
    adaptiveHeight: false,
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: true
  });
}
